var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "p-0" },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { staticClass: "mr-6 mb-3" },
                [
                  _c("SButton", {
                    attrs: {
                      sText: _vm.$t(
                        "teamRequestDetail.buttonGroup.manager.pending.approve"
                      ),
                      btnStyle: "primary",
                      action: _vm.approveRequest,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                [
                  _c("SButton", {
                    attrs: {
                      sText: _vm.$t(
                        "teamRequestDetail.buttonGroup.manager.pending.reject"
                      ),
                      btnStyle: "secondary",
                      action: _vm.cancelRequest,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("SButton", {
                attrs: {
                  sText: _vm.$t(
                    "teamRequestDetail.buttonGroup.manager.validated.newProposal"
                  ),
                  btnStyle: "primary",
                  action: _vm.sendProposal,
                  disabled: _vm.disabled,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }